import { css } from 'styled-components';

export const main = () => css`
  white-space: pre-line;
`;
